// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__Os3FW","inputs":"Stand_inputs__TKAR7","buttons":"Stand_buttons__R3hDp","checkboxes":"Stand_checkboxes__S-Yx5"};